import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ClassIcon, GroupIcon, StudentIcon } from '../../helpers/icon-dictionary';
import SvgIcon from '../svg-icon/svg-icon';
import { StudentLegendShell } from '../doughnuts/styled';

const DoughnutsLegend = ({ i18n, type, studentName }) => {
  const ClassLegend = () => (
    <div className="legend-shell">
      <div className="class color-indi" />
      <SvgIcon icon={ClassIcon} />
      <p className="text-indi">{i18n.t`Class`}</p>
    </div>
  );

  const GroupLegend = () => (
    <div className="legend-shell">
      <div className="group color-indi" />
      <SvgIcon icon={GroupIcon} />
      <p className="text-indi">{i18n.t`Group`}</p>
    </div>
  );

  const noStudentName = studentName === ' ';

  const StudentLegend = () => (
    <StudentLegendShell className="legend-shell" noStudentName={noStudentName}>
      <div className="student color-indi" />
      <SvgIcon icon={StudentIcon} />
      <p className="text-indi student-text">{noStudentName ? i18n.t`Student name` : studentName}</p>
    </StudentLegendShell>
  );

  const items = [
    (<ClassLegend />),
    (<Fragment><GroupLegend /><ClassLegend /></Fragment>),
    (<Fragment><StudentLegend /><GroupLegend /><ClassLegend /></Fragment>)
  ];
  return items[type];
};

DoughnutsLegend.propTypes = {
  i18n: PropTypes.object,
  type: PropTypes.number,
  studentName: PropTypes.string
};

export default DoughnutsLegend;
